export default __webpack_public_path__ + "static/media/README.95d37ecd.md";